import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-table-grip',
  template: `
    <span class="grip-cell">
      <div class="grip-container" [ngClass]="{ disabled }">
        <div class="grip-column">
          <div class="grip"></div>
          <div class="grip"></div>
          <div class="grip"></div>
        </div>
        <div class="grip-column">
          <div class="grip"></div>
          <div class="grip"></div>
          <div class="grip"></div>
        </div>
      </div>
    </span>
  `,
  styles: `
    .grip-container {
      display: flex;
      justify-content: center;
    }

    .grip-column {
      display: flex;
      flex-direction: column;
    }

    .grip {
      background: #c0c0c0;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      margin: 2px;
      border: 1px solid #9d9d9d;
    }
    .disabled .grip {
      opacity: 25%;
    }
  `,
  imports: [NgClass],
})
export class TableGripComponent {
  @Input() disabled: boolean = false;
}
